module.exports = " <div _v-1a0dd9dd=\"\"> <img :src=iconImageSource v-if=iconImageSource _v-1a0dd9dd=\"\"> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-1a0dd9dd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderIconImage.vue
// module id = 379
// module chunks = 2